export var OtherTagExtractors = {
    id: function (u) { return u.id; },
    name: function (u) { return u.name; },
    fullName: function (u) { var _a; return (_a = u.fullName) !== null && _a !== void 0 ? _a : u.name; },
    color: function (u) { return u.color; },
};
